import { useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfter = ({ before, after, title, tag, beforeRotate, afterRotate }) => {
  const [pos, setPos] = useState(50);
  const rot = "rotate-90 scale-125";

  return (
    <div className="group">
      <div className="relative aspect-[16/10] w-full select-none overflow-hidden">
        {/* After (base) */}
        <img
          src={after}
          alt={`${title} after`}
          className={`absolute inset-0 h-full w-full object-cover ${afterRotate ? rot : ""}`}
          draggable={false}
        />
        <span className="absolute right-4 top-4 z-20 bg-obsidian/70 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-white backdrop-blur">
          After
        </span>

        {/* Before (clipped) */}
        <div
          className="absolute inset-0 overflow-hidden"
          style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        >
          <img
            src={before}
            alt={`${title} before`}
            className={`absolute inset-0 h-full w-full object-cover ${beforeRotate ? rot : ""}`}
            draggable={false}
          />
          <span className="absolute left-4 top-4 z-20 bg-obsidian/70 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-ember backdrop-blur">
            Before
          </span>
        </div>

        {/* Handle */}
        <div className="pointer-events-none absolute inset-y-0 z-20" style={{ left: `${pos}%` }}>
          <div className="mx-auto h-full w-0.5 -translate-x-1/2 bg-white/90" />
          <div className="absolute top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-obsidian shadow-lg">
            <MoveHorizontal className="h-5 w-5" />
          </div>
        </div>

        <input
          type="range"
          min="0"
          max="100"
          value={pos}
          onChange={(e) => setPos(Number(e.target.value))}
          aria-label={`${title} before and after slider`}
          data-testid="beforeafter-slider"
          className="absolute inset-0 z-30 h-full w-full cursor-ew-resize opacity-0"
        />
      </div>
      <div className="mt-5 flex items-center justify-between">
        <h3 className="font-display text-2xl font-light text-white">{title}</h3>
        <span className="text-[11px] uppercase tracking-[0.2em] text-sand">{tag}</span>
      </div>
    </div>
  );
};
